<div class="w-full pr-10 gap-6 flex flex-col">
  <div class="flex w-full justify-between">
    <div class="w-full pt-4">
     
      
    </div>
    <div class="flex items-center justify-end w-full">
      <div class="flex flex-col items-center">
        <div class="h-6 w-6 text-center rounded-full bg-primary text-white">
          1
        </div>
        <span class="text-white">Registration</span>
      </div>
      <img
        *ngIf="showPortalBuilder"
        src="../../../../assets/image/line.svg"
        alt=""
      />
      <div *ngIf="showPortalBuilder" class="flex flex-col items-center">
        <div
          class="h-6 w-6 text-center rounded-full portal-builder-num text-white"
        >
          2
        </div>
        <span class="text-white">Portal Builder</span>
      </div>
      <div *ngIf="showCustomerProfile" class="w-40 h-[2px] bg-white"></div>
      <div *ngIf="showCustomerProfile" class="flex flex-col items-center">
        <div
          class="h-6 w-6 text-center rounded-full portal-builder-num text-white"
        >
          2
        </div>
        <span class="text-white">Customer Profile</span>
      </div>
    </div>
  </div>
  <form [formGroup]="createUserForm" class="login-container w-full">
    <div class="flex h-full gap-10 w-full flex-col xl:flex-row">
      <div class="w-full flex flex-col gap-6">
        <div class="w-full bg-white rounded-xl h-full">
          <div class="flex p-4 space-x-2 items-center">
            <div class="h-8 w-[4px] bg-primary"></div>
            <span>{{ roleOnboading }} Onboarding</span>
          </div>

          <div class="p-4 flex flex-col gap-4">
            <div class="flex flex-col gap-2">
              <span class="text-sm">Select User Type *</span>

              <select
                (change)="getRoleData($event)"
                class="w-full p-2 outline-none border rounded-md"
                formControlName="role"
                name="role"
              >
                <option value="" disabled>Select Type</option>
                <option *ngFor="let role of rolesList" [value]="role._id">
                  {{ role.title }}
                </option>
              </select>
              <div
                *ngIf="
                  createUserForm.controls['role'].touched &&
                  !createUserForm.controls['role'].valid
                "
                class="text-red-500"
              >
                Please Select User Type
              </div>
            </div>
            <div class="flex flex-col gap-2" >
              <span class="text-sm">Vendor Name *</span>

              <input [readonly]="userRole != 'admin'"
                formControlName="businessName"
                name="businessName"
                placeholder="Enter Your Vendor Name"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  createUserForm.controls['businessName'].touched &&
                  !createUserForm.controls['businessName'].valid
                "
                class="text-red-500"
              >
              Vendor Name Is Required
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="text-sm">{{ referalName }}*</span>
              <input
                placeholder="Enter Your {{ referalName }}"
                formControlName="name"
                name="name"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  createUserForm.controls['name'].touched &&
                  !createUserForm.controls['name'].valid
                "
                class="text-red-500"
              >
                Please Enter {{ referalName | titlecase }}
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <span class="text-sm">Enter {{ roleOnboading }} Email *</span>

              <input
                placeholder="Enter {{ roleOnboading }} email"
                formControlName="email"
                name="email"
                class="w-full border p-2 rounded-md outline-none"
              />
              <div
                *ngIf="
                  createUserForm.controls['email'].touched &&
                  !createUserForm.controls['email'].valid
                "
                class="text-red-500"
              >
                Invalid Email
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="text-sm">Password *</span>
              <div class="flex relative">
                <input
                  placeholder="**************"
                  [type]="showPassword ? 'password' : 'text'"
                  formControlName="password"
                  name="password"
                  class="w-full border p-2 rounded-md outline-none"
                />
                <img
                  *ngIf="showPassword"
                  (click)="showPassword = false"
                  src="../../../assets/image/eye.svg"
                  alt=""
                  height="20"
                  width="20"
                  class="absolute top-3 right-4"
                />
                <img
                  *ngIf="!showPassword"
                  (click)="showPassword = true"
                  src="../../../assets/image/closeeye.svg"
                  alt=""
                  height="20"
                  width="20"
                  class="absolute top-3 right-4"
                />
              </div>
              <div
                *ngIf="
                  createUserForm.controls['password'].touched &&
                  (!createUserForm.controls['password'].valid ||
                    createUserForm.get('password')?.hasError('pattern'))
                "
                class="text-red-500"
              >
                Password must be 8+ characters with 1 uppercase, 1 lowercase, 1
                number, and 1 special character: &#64;$!%*?&.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full bg-white p-4 rounded-xl h-full">
        <div class="p-8 flex flex-col gap-4">
          <div class="flex flex-col gap-2">
            <span class="text-sm">Select Industry Type *</span>
            <select
              (change)="getIndustryTypeData($event)"
              class="w-full p-2 outline-none border rounded-md"
              formControlName="industryType"
              name="industryType"
            >
              <option value="" disabled>Select Type</option>
              <option
                *ngFor="let industry of industryTypeList"
                [value]="industry._id"
              >
                {{ industry.title }}
              </option>
            </select>
            <div
              *ngIf="
                createUserForm.controls['industryType'].touched &&
                !createUserForm.controls['industryType'].valid
              "
              class="text-red-500"
            >
              Please Select Industry Type
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="text-sm">Primary Phone *</span>

            <input
              formControlName="phone"
              name="phone"
              maxlength="10"
              placeholder="Enter Your Phone Number"
              class="w-full border p-2 rounded-md outline-none"
              (keypress)="keyPressNumbers($event)"
            />
            <div
              *ngIf="
                createUserForm.controls['phone'].touched &&
                (!createUserForm.controls['phone'].valid ||
                  createUserForm.get('phone')?.hasError('pattern'))
              "
              class="text-red-500"
            >
              Invalid Phone Number
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="text-sm">Alternative Phone (Optional)</span>

            <input
              formControlName="alternatePhone"
              name="alternatePhone"
              maxlength="10"
              placeholder="Enter Your Alternative Phone"
              class="w-full border p-2 rounded-md outline-none"
              (keypress)="keyPressNumbers($event)"
            />
          </div>
          <div
            *ngIf="
              createUserForm.controls['alternatePhone'].touched &&
              (!createUserForm.controls['alternatePhone'].valid ||
                createUserForm.get('alternatePhone')?.hasError('pattern'))
            "
            class="text-red-500"
          >
            Invalid Phone Number
          </div>

          <div class="flex flex-col gap-2">
            <span class="text-sm">Website *</span>

            <input
              formControlName="website"
              name="website"
              placeholder="Enter Your Website"
              class="w-full border p-2 rounded-md outline-none"
            />
            <div
              *ngIf="
                createUserForm.controls['website'].touched &&
                (!createUserForm.controls['website'].valid ||
                  createUserForm.get('website')?.hasError('pattern'))
              "
              class="text-red-500"
            >
              Invalid URL
            </div>
          </div>

          <div class="flex flex-col gap-2" *ngIf="isMerchant">
            <span class="text-sm">Merchant Code * </span>

            <input
              placeholder="Enter Merchant Code"
              formControlName="merchantCode"
              name="merchantCode"
              maxlength="5"
              class="w-full border p-2 rounded-md outline-none"
            />
            <div
              *ngIf="
                createUserForm.controls['merchantCode'].touched &&
                !createUserForm.controls['merchantCode'].valid
              "
              class="text-red-500"
            >
              Please enter merchant code
            </div>
          </div>
          <div class="flex flex-col gap-2" *ngIf="isReseller">
            <span class="text-sm">Reseller Code *</span>

            <input
              placeholder="Enter Reseller Code "
              maxlength="5"
              formControlName="resellerCode"
              name="resellerCode"
              class="w-full border p-2 rounded-md outline-none"
            />
            <div
              *ngIf="
                createUserForm.controls['resellerCode'].touched &&
                !createUserForm.controls['resellerCode'].valid
              "
              class="text-red-500"
            >
              Please enter reseller code
            </div>
          </div>

          <div class="flex flex-col gap-2">
            <div class="bg-white border-2 rounded-xl border-[#0058e9]">
              <div class="p-5 flex items-center justify-center">
                <div *ngIf="!imageurl" class="w-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 11.1L7 9.1L12.5 14.6L16 11.1L19 14.1V5H5V11.1ZM5 13.929V19H8.1L11.086 16.015L7 11.929L5 13.929ZM19 19H10.929L16 13.929L19 16.929V19ZM14 8.5C14 9.32843 14.6716 10 15.5 10C16.3284 10 17 9.32843 17 8.5C17 7.67157 16.3284 7 15.5 7C14.6716 7 14 7.67157 14 8.5Z"
                      fill="#525B69"
                    />
                  </svg>
                </div>
                <div class="h-30 w-40">
                  <img
                    *ngIf="imageurl"
                    [src]="imageurl"
                    alt="Profile Image"
                    class="h-40 w-40"
                  />
                </div>
              </div>
              <div
                class="bg-primary text-[10px] text-white py-3 px-4 rounded-b-lg py-1"
              >
                <h1 class="text-center" style="font-size: 14px">Change Picture</h1>
              </div>
            </div>
    
            <div class="flex gap-4">
              <div class="flex flex-col w-full justify-end">
                <button>
                  <label
                    for="fileInput"
                    title="File should be Jpeg, PNG and less than 3 MB"
                    class="bg-primary text-white px-3 py-2 rounded-lg flex items-center cursor-pointer justify-center gap-2"
                  >
                    <span class="flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1977_10834)">
                          <path
                            d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z"
                            fill="#F5F5F5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1977_10834">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    Upload
                  </label>
                </button>
               
                <input
                  type="file"
                  id="fileInput"
                  title="File should be Jpeg, PNG less than 3 MB"
                  (change)="handleFileInput($event)"
                  accept=".jpg,.jpeg,.png"
                  style="display: none"
                />
                <span class="tooltip">File should be Jpeg, PNG less than 3 MB</span>
              </div>
    
         
    
              <div
                *ngIf="errorMessage1"
                class="file-error text-[#d60000] text-[14.241px]"
              >
                {{ errorMessage1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </form>

  <div class="w-full flex items-center justify-end">
    <button
      (click)="createUser()"
      class="rounded-xl p-3 w-60 text-white bg-primary"
    >
      Register
    </button>
  </div>
</div>
